import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, Icon } from "@shopify/polaris";
import { SearchIcon } from "@shopify/polaris-icons";
import { alegraRequest, isPickableAlegraProduct } from "../../utility/invoicing";

// Search-as-you-type picker over EXISTING Alegra products, for manual concept
// lines. Invoices must reuse a product: creating one per free-text line split
// Alegra's product reports into hundreds of duplicates.
export default function AlegraProductPicker({ label, onSelect }) {
  const [input, setInput] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const byId = useRef(new Map());

  useEffect(() => {
    const term = input.trim();
    if (term.length < 3) {
      setOptions([]);
      return undefined;
    }
    let cancelled = false;
    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const found = await alegraRequest(`items?query=${encodeURIComponent(term)}`, "GET");
        if (cancelled) return;
        const list = (Array.isArray(found) ? found : []).filter(isPickableAlegraProduct);
        byId.current = new Map(list.map((i) => [String(i.id), i]));
        setOptions(list.map((i) => ({ value: String(i.id), label: i.name })));
      } catch {
        if (!cancelled) setOptions([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }, 400);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [input]);

  return (
    <Autocomplete
      options={options}
      selected={[]}
      loading={loading}
      onSelect={(selected) => {
        const product = byId.current.get(selected[0]);
        if (product) onSelect(product);
      }}
      emptyState={
        input.trim().length >= 3 && !loading
          ? "Sin productos. Pide a contabilidad darlo de alta en Alegra."
          : undefined
      }
      textField={
        <Autocomplete.TextField
          label={label || "Producto"}
          labelHidden={!label}
          value={input}
          onChange={setInput}
          prefix={<Icon source={SearchIcon} />}
          placeholder="Buscar producto en Alegra"
          autoComplete="off"
        />
      }
    />
  );
}
